import { useEffect, useRef, useState } from "react";
import Navbar from "@/components/Navbar";
import TrustBar from "@/components/TrustBar";

/**
 * SiteHeader
 *
 * Phase 2 fix: the Navbar is `position: fixed`, but the TrustBar used to sit
 * in normal document flow directly after it — so the TrustBar rendered
 * *underneath* the navbar and page content started at y=0.
 *
 * Both bars are now inside one fixed wrapper, and a spacer of the measured
 * wrapper height reserves the same space in flow. The height is measured with
 * a ResizeObserver so responsive navbar heights (h-16 / h-20 / h-28) and
 * TrustBar wrapping never cause overlap or a layout jump on scroll.
 */
const SiteHeader = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<number | null>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const measure = () => setHeight(el.getBoundingClientRect().height);
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    window.addEventListener("orientationchange", measure);
    return () => {
      ro.disconnect();
      window.removeEventListener("orientationchange", measure);
    };
  }, []);

  return (
    <>
      <div ref={ref} className="fixed top-0 left-0 right-0 z-50">
        <Navbar />
        <TrustBar />
      </div>
      {/* Flow spacer. Falls back to the CSS-only combined height before the
          first measurement (and during SSR) so there is no initial jump. */}
      <div
        aria-hidden
        className={height === null ? "h-24 sm:h-28 lg:h-36" : undefined}
        style={height === null ? undefined : { height }}
      />
    </>
  );
};

export default SiteHeader;
